<div class="title p-2">
    <div class="row">
        <div class="col d-flex justify-content-start">
            <h1 class="mx-1">Încarcă exemplar Cetățean</h1>
        </div>
        <div class="col d-flex justify-content-end">
            <button type="button" class="action-btn" (click)="closeDialog()">
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </div>
</div>

<div class="container p-2">
    <div class="row">
        <div class="col">
            <form [formGroup]="uploadForm" (ngSubmit)="submit()">

                <!-- Upload Exemplar Cetățean -->
                <div class="row">
                    <div class="col">
                        <div class="solicitare-card__upload">
                            <div class="solicitare-card__upload-header">
                                <p class="upload-text">
                                    <i class="fa-solid fa-file-pdf me-2"></i>
                                    Încărcare exemplar Cetățean
                                </p>
                                <button class="upload-btn" (click)="fileInput.click()" type="button">
                                    <mat-icon class="upload-icon">cloud_upload</mat-icon>
                                    ÎNCARCĂ
                                </button>
                            </div>

                            <div class="solicitare-card__upload-files"
                                *ngIf="uploadForm.get('exemplarCetatean')?.value && !isUploading">
                                <div class="solicitare-card__upload-file">
                                    <span class="solicitare-card__upload-file-name">
                                        {{ (uploadForm.get('exemplarCetatean')?.value.original_name.length > 30) ?
                                        (uploadForm.get('exemplarCetatean')?.value.original_name | slice: 0:30) + '..' :
                                        (uploadForm.get('exemplarCetatean')?.value.original_name) }}
                                    </span>
                                    <div>
                                        <button class="solicitare-card__upload-file-delete" type="button"
                                            matTooltip="Șterge fișierul încărcat" (click)="removeFile()">
                                            <img class="btn-img" src="assets/icons/delete.svg" alt="" />
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <mat-spinner diameter="32" style="margin-right: 8px; margin-top: 4px"
                                *ngIf="isUploading"></mat-spinner>

                            <input type="file" accept="application/pdf" id="upload-cetatean-file-input" #fileInput
                                name="fileInput" (change)="addFile($event)" style="display: none">
                        </div>
                    </div>
                </div>

                <!-- Butoane Actiune -->
                <div class="row mt-4">
                    <div class="col">
                        <div class="d-flex justify-content-end">
                            <button type="button" class="buttons me-2" mat-flat-button (click)="closeDialog()">
                                {{ helper.dialogConfig.buttonLabels.close }}
                            </button>
                            <button class="buttons" mat-flat-button color="primary" type="submit"
                                [disabled]="uploadForm.invalid || isLoading || isUploading">
                                Încarcă
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>

<div class="section-spinner position-absolute" *ngIf="isLoading">
    <div class="spinner position-absolute top-50 start-50 translate-middle">
        <mat-spinner></mat-spinner>
        <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
    </div>
</div>
